import * as React from 'react';
import { FC } from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import PreviewItem from '../PreviewItem';
import * as classNames from 'classnames';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            display: 'flex',
            flexWrap: 'wrap',
            [mediaQueries.Tablet]: {
                marginLeft: -spacing.Gutter.Desktop / 2,
                marginRight: -spacing.Gutter.Desktop / 2,
            },
            [mediaQueries.Laptop]: {
                marginLeft: -spacing.Gutter.Desktop / 2,
                marginRight: -spacing.Gutter.Desktop / 2,
            },
            [mediaQueries.Desktop]: {
                marginLeft: -spacing.Gutter.Desktop / 2,
                marginRight: -spacing.Gutter.Desktop / 2,
            },
        },
        panel: {
            boxSizing: 'border-box',
            [mediaQueries.Mobile]: {
                width: '100%',
                marginBottom: spacing.Gutter.Mobile * 2,
            },
            [mediaQueries.AfterMobile]: {
                width: `${1 / 3 * 100}%`,
                '&$isProductPage': {
                    width: `${1 / 2 * 100}%`,
                },
            },
            [mediaQueries.Tablet]: {
                paddingLeft: spacing.Gutter.Tablet / 2,
                paddingRight: spacing.Gutter.Tablet / 2,
                marginBottom: spacing.Gutter.Tablet * 2,
            },
            [mediaQueries.Laptop]: {
                paddingLeft: spacing.Gutter.Laptop / 2,
                paddingRight: spacing.Gutter.Laptop / 2,
                marginBottom: spacing.Gutter.Laptop * 2,
            },
            [mediaQueries.Desktop]: {
                paddingLeft: spacing.Gutter.Desktop / 2,
                paddingRight: spacing.Gutter.Desktop / 2,
                marginBottom: spacing.Gutter.Desktop * 2,
            },
        },
        isProductPage: {},
    }));

export type PanelReferenceProps = PanelReferenceDto & { isProductPage?: boolean };
type Props = PanelReferenceProps;

const PanelReference: FC<Props> = ({ ReferenceItems, isProductPage }) => {
    const cls = useStyles();

    return (
        <div className={cls.root}>
            {ReferenceItems.map((item, i) =>
                <div
                    key={`panel-reference-${i}`}
                    className={classNames(cls.panel, isProductPage && cls.isProductPage)}
                >
                    <PreviewItem previewItem={item} />
                </div>
            )}
        </div>
    );
}

export default PanelReference;


// WEBPACK FOOTER //
// ./src/Components/Panels/PanelReference.tsx